import { render, staticRenderFns } from "./safeRescured.vue?vue&type=template&id=0db80848&scoped=true&"
import script from "./safeRescured.vue?vue&type=script&lang=js&"
export * from "./safeRescured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db80848",
  null
  
)

export default component.exports